module.exports = __webpack_public_path__ + "static/media/zocaloPvcJ2.5e1cfcf4.jpg";